/** API route map: URLS.Controller.PayrollSicCodeSetup */
export const PayrollSicCodeSetup = {
      Name: 'PayrollSicCodeSetup/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetSICCode: 'get-sic-code',
      GetJSICclients: 'get-clients',
};
